export default "__VITE_ASSET__3c770a6e__"